module.exports = {
  config: {
    apiKey: 'AIzaSyDGIMJgBBt78ms4p_KRY-e2wehvtalyiZ4',
    authDomain: 'lma-fes-stg-48353.firebaseapp.com',
    databaseURL: 'https://lma-fes-stg-48353.firebaseio.com',
    projectId: 'lma-fes-stg-48353',
    storageBucket: 'lma-fes-stg-48353.appspot.com',
    messagingSenderId: '522529790407',
    appId: '1:522529790407:web:560aaba604c7fa1cb021e2',
    measurementId: 'G-XD6W2XN99M'
  },
  // API_URL: 'http://local-api.l-ma.co.jp:8888',
  // NEW_API_URL: 'http://127.0.0.1:8080'
  API_URL: 'https://stg.l-ma.co.jp',
  NEW_API_URL: ' https://stg-api.l-ma.co.jp'
}
